import { useEffect } from "react";

const NoOverlay = ({ children }) => {
  useEffect(() => {
    const node: HTMLElement | null = document.querySelector(
      "div[data-testid=underlay]",
    );
    if (node && node) {
      node.style.display = "none";
    }
  }, []);

  return children;
};

export default NoOverlay;
